import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import { Formik } from "formik";
import {
  Alert,
  Autocomplete,
  Avatar,
  CircularProgress,
  createTheme,
  Divider,
  FormHelperText,
  Grid2,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TextField,
  ThemeProvider,
  Typography,
  useTheme,
} from "@mui/material";
import * as Yup from "yup";
import { useState } from "react";
import DragAndDropUpload from "components/FileUploader/DragAndDropUpload";
import {
  useGetPackagesQuery,
  useLazyGetPackagesQuery,
} from "store/slices/apis/packageSlice";
import { useGetContractorQuery } from "store/slices/apis/contractors";
import {
  useAddKeyIssueMutation,
  useEditKeyIssueMutation,
  useGetKeyIssueQuery,
} from "store/slices/apis/keyIssueSlice";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import { FaRegFileLines } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import { API_END_POINT } from "config";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useGetAllWorkflowQuery } from "store/slices/apis/workflowSlice";
import {ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const currentStatuses = [
  { label: "Open", year: 1994 },
  { label: "Close", year: 1972 },
];

const users = [
  { label: "Structural Engineer 1", year: 1994 },
  { label: "Structural Engineer 2", year: 1972 },
  { label: "Structural Engineer 3", year: 1972 },
];

const moduleTypes = [
  { label: "Manpower", value: "Manpower" },
  { label: "Procurement", value: "Procurement" },
  { label: "P&M", value: "P&M" },
];

const severityTypes = [
  { label: "Low", value: "low" },
  { label: "Medium", value: "medium" },
  { label: "High", value: "high" },
  { label: "Critical", value: "critical" },
];

export default function EditIssue(props) {
  const { open, cancelIssue, openNotification, data, isViewIssueModal } = props;
  const newtheme = useTheme();
  const { projectId } = useParams();
  const [file, setFile] = useState(null);
  const [dense, setDense] = useState(false);
  const [secondary, setSecondary] = useState(false);
  const { data: packages } = useGetPackagesQuery({ projectId: projectId });
  const { data: contractors } = useGetContractorQuery();
  const { data: issueDetail, isSuccess: issueDetailSuccess } =
    useGetKeyIssueQuery(data?.id);

  const [getSubPackage1, { data: subPackageList1 }] = useLazyGetPackagesQuery();
  const [getSubPackage2, { data: subPackageList2 }] = useLazyGetPackagesQuery();
  // const [getSubPackage3, { data: subPackageList3 }] = useLazyGetPackagesQuery();
  // const [getSubPackage4, { data: subPackageList4 }] = useLazyGetPackagesQuery();
  // const [getSubPackage5, { data: subPackageList5 }] = useLazyGetPackagesQuery();
  // const [getSubPackage6, { data: subPackageList6 }] = useLazyGetPackagesQuery();
  // const [getSubPackage7, { data: subPackageList7 }] = useLazyGetPackagesQuery();
  const workflowList = useGetAllWorkflowQuery({ projectId, pageNumber: 1, pageSize: 100, entityName: 'Issue' })

  const [
    editKeyIssue,
    { data: editKeyIssueRes, isLoading, isSuccess, isError, error },
  ] = useEditKeyIssueMutation();

  const [formData, setFormData] = useState({
    contractor: "",
    package: "",
    subPackage1: "",
    subPackage2: "",
    subPackage3: "",
    subPackage4: "",
    subPackage5: "",
    subPackage6: "",
    subPackage7: "",
    currentStatus: "",
    issueDescription: "",
    actionRequiredBy: "",
    // document: '',
    timeImpact: "",
    costImpact: "",
    module: "",
    severity: "",
    reportedDate: "",
    projectId,
  });

  // Fetch data when modal loads
  useEffect(() => {
    getSubPackage1({ projectId: projectId, type: "subPackage1" });
    getSubPackage2({ projectId: projectId, type: "subPackage2" });
    // getSubPackage3({ projectId: projectId, type: "subPackage3" });
    // getSubPackage4({ projectId: projectId, type: "subPackage4" });
    // getSubPackage5({ projectId: projectId, type: "subPackage5" });
    // getSubPackage6({ projectId: projectId, type: "subPackage6" });
    // getSubPackage7({ projectId: projectId, type: "subPackage7" });
  }, [open]); // Runs once when modal mounts

  const theme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            border: "2px solid #e6e6e6",
            "& .MuiFilledInput-input": {
              backgroundColor: "#fff",
              color: "#252525",
              fontSize: "16px",
            },
            "& .MuiFilledInput-root::before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root::after": {
              borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`,
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#696969",
              fontSize: "14px",
            },
            "& .MuiFormLabel-root": {
              fontSize: "15px",
            },
            "& .MuiFilledInput-root.Mui-disabled:before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root": {
              backgroundColor: "#fff",
            },
            "& .MuiFilledInput-input": {
              backgroundColor: "none",
              fontSize: "14px",
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#696969",
            },
            "& .MuiFilledInput-root.Mui-disabled": {
              backgroundColor: "#fff",
              color: "inherit",
            },
            "& .MuiFilledInput-input.Mui-disabled": {
              WebkitTextFillColor: "#696969",
              opacity: "none",
            },
          },
        },
      },
    },
  });

  useEffect(() => {
    if (issueDetailSuccess) {
      setFormData({
        contractor: issueDetail?.data?.contractor || "",
        package: issueDetail?.data?.package || "",
        subPackage1: issueDetail?.data?.subPackage1 || "",
        subPackage2: issueDetail?.data?.subPackage2 || "",
        // subPackage3: issueDetail?.data?.subPackage3 || "",
        // subPackage4: issueDetail?.data?.subPackage4 || "",
        // subPackage5: issueDetail?.data?.subPackage5 || "",
        // subPackage6: issueDetail?.data?.subPackage6 || "",
        // subPackage7: issueDetail?.data?.subPackage7 || "",
        currentStatus: issueDetail?.data?.currentStatus || "",
        issueDescription: issueDetail?.data?.issueDescription || "",
        actionRequiredBy: issueDetail?.data?.actionRequiredBy || "",
        actionRequiredByEmail: issueDetail?.data?.actionRequiredByEmail || "",
        timeImpact: issueDetail?.data?.timeImpact || "",
        costImpact: issueDetail?.data?.costImpact || "",
        module: issueDetail?.data?.module || "",
        severity: issueDetail?.data?.severity || "",
        reportedDate: issueDetail?.data?.reportedDate || "",
        workflowApprovalId: issueDetail?.data?.workflowApprovalId || "",
        projectId,
      });
    }
  }, [issueDetailSuccess]);
  const handleClose = () => {
    // setOpen(false);
  };

  // const handleMaxWidthChange = (event) => {
  //     setMaxWidth(
  //         // @ts-expect-error autofill of arbitrary value is not handled.
  //         event.target.value,
  //     );
  // };

  // const handleFullWidthChange = (event) => {
  //     setFullWidth(event.target.checked);
  // };

  const validationSchema = Yup.object({
    // WorkflowApprovalId: Yup.string().required("Workflow field is required."),
    // contractor: Yup.string().required("Contractor field is required."),
    package: Yup.string().required("Package field is required."),
    subPackage1: Yup.string().required("Sub Package 1 field is required."),
    subPackage2: Yup.string().required("Sub Package 2 field is required."),
    // subPackage3: Yup.string().required("Sub Package 3 field is required."),
    // subPackage4: Yup.string().required("Sub Package 4 field is required."),
    // subPackage5: Yup.string().required("Sub Package 5 field is required."),
    // subPackage6: Yup.string().required("Sub Package 6 field is required."),
    // subPackage7: Yup.string().required("Sub Package 7 field is required."),
    currentStatus: Yup.string().required("Current status field is required."),
    module: Yup.string().required("Module field is required."),
    severity: Yup.string().required("Severity field is required."),
    reportedDate: Yup.date()
      .required("Reporting Date is required")
      .nullable()
      .typeError("Reporting Date must be a valid date"),
    issueDescription: Yup.string().required(
      "Issue description field is required."
    ),
    actionRequiredBy: Yup.string().required(
      "Action required by field is required."
    ),
    actionRequiredByEmail: Yup.string()
      .email()
      .required("Action required by Email field is required."),
    timeImpact: Yup.number()
      // .positive()
      .integer()
      .required("Time Impact field is required."),
    costImpact: Yup.number()
      // .positive()
      .integer()
      .required("Cost Impact field is required."),
  });

  const handleDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      openNotification("File type must be image/*");
      return;
    }
    // setFile(acceptedFiles);
    setFile((prevFiles) => {
      if (!Array.isArray(prevFiles)) {
        prevFiles = [];
      }
      return [...prevFiles, ...acceptedFiles];
    });
  };

  const handleRemoveFile = (index) => {
    setFile((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {

    const formattedValues = {
      ...values,
      reportedDate:
        values?.reportedDate && dayjs(values.reportedDate).isValid()
          ? dayjs(values.reportedDate).format("YYYY-MM-DD") +
          "T00:00:00.000000Z"
          : null,
    };
    try {
      // let handleFormData = {
      //     issueJson: ,
      //     // file: file
      // }

      const formData = new FormData();
      formData.append(
        "issueJson",
        JSON.stringify({
          ...formattedValues,
          id: data?.id,
          IssueNumber: data?.issueNumber,
        })
      );
      if (file != null) {
        // formData.append('file', file[0])
        file?.map((value, key) => {
          formData.append("file", value);
        });
      }

      const response = await editKeyIssue({
        id: data?.id,
        body: formData,
      }).unwrap();
      if (response?.status == "Success") {
        openNotification(response?.message, "success");
        setFile(null);
        cancelIssue();
      } else {
        openNotification(response?.message);
      }
    } catch (error) {
      openNotification(error?.error, "error");
    } finally {
      setSubmitting(false);
    }
  };

  const CustomCalendarIcon = (props) => (
      <CalendarIcon {...props} style={{ width: 26, height: 26, fill:"#696969 ", stroke:"#696969", strokeWidth:4 }} />
    );

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            overflowY: "inherit",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "20px", color: "#696969" }}>
          {isViewIssueModal ? "View" : "Edit"} Issue
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancelIssue}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
          <CrossIcon style={{ fontSize: "20px", width:"20px", height:"20px", fill:"#808080" }} />
        </IconButton>
        <Divider sx={{ w: 1 }} />
        <DialogContent>
          <ThemeProvider theme={theme}>
            <Box sx={{ mt: 1 }}>
              <Formik
                initialValues={formData}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  setTouched,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid2 container spacing={2}>
                      <Grid2 size={12}>
                        <Typography
                          variant="h4"
                          gutterBottom
                          sx={{ fontSize: "20px", color: "#252525" }}
                        >
                          Select Categories
                        </Typography>
                      </Grid2>

                      <Grid2 size={{xs: 12, md: 6}}>
                        <Autocomplete
                          options={packages?.data}
                          disabled={isViewIssueModal}
                          getOptionLabel={(option) => option}
                          value={
                            packages?.data?.find(
                              (option) => option === values.package
                            ) || null
                          }
                          onChange={(_, newValue) => {
                            setFieldValue(
                              "package",
                              newValue ? newValue : ""
                            );
                            setFieldValue("subPackage1", "");
                            setFieldValue("subPackage2", "");
                            // setFieldValue("subPackage3", "");
                            // setFieldValue("subPackage4", "");
                            // setFieldValue("subPackage5", "");
                            // setFieldValue("subPackage6", "");
                            // setFieldValue("subPackage7", "");
                          }}
                          onBlur={() =>
                            setTouched({ ...touched, package: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Category"
                              name="package"
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.package && errors?.package && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.package}`}</FormHelperText>
                        )}
                      </Grid2>
                      {values?.package && (
                        <Grid2 size={{xs: 12, md: 6}}>
                          <Autocomplete
                            options={subPackageList1?.data}
                            disabled={isViewIssueModal}
                            getOptionLabel={(option) => option}
                            value={
                              subPackageList1?.data?.find(
                                (option) =>
                                  option === values?.subPackage1
                              ) || null
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage1",
                                newValue ? newValue : ""
                              );
                              setFieldValue("subPackage2", "");
                              // setFieldValue("subPackage3", "");
                              // setFieldValue("subPackage4", "");
                              // setFieldValue("subPackage5", "");
                              // setFieldValue("subPackage6", "");
                              // setFieldValue("subPackage7", "");
                              // getSubPackage2({ projectId: 'fc622678-6730-4027-806e-9d9bc07f306a', type: 'subPackage2' })
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage1: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 1"
                                name="subPackage1"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage1 && errors?.subPackage1 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage1}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}
                      {values?.subPackage1 && (
                        <Grid2 size={{xs: 12, md: 6}}>
                          <Autocomplete
                            options={subPackageList2?.data}
                            disabled={isViewIssueModal}
                            getOptionLabel={(option) => option}
                            value={
                              subPackageList2?.data?.find(
                                (option) =>
                                  option === values?.subPackage2
                              ) || null
                            }
                            onChange={(_, newValue) => {
                              setFieldValue(
                                "subPackage2",
                                newValue ? newValue : ""
                              );
                              // setFieldValue("subPackage3", "");
                              // setFieldValue("subPackage4", "");
                              // setFieldValue("subPackage5", "");
                              // setFieldValue("subPackage6", "");
                              // setFieldValue("subPackage7", "");
                              // getSubPackage3({ projectId: 'fc622678-6730-4027-806e-9d9bc07f306a', type: 'subPackage3' })
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, subPackage2: true })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Sub Category 2"
                                name="subPackage2"
                                slotProps={{ inputLabel: { shrink: true } }}
                                variant="filled"
                              />
                            )}
                            ListboxProps={{
                              sx: { fontSize: "13px" },
                            }}
                          />
                          {touched?.subPackage2 && errors?.subPackage2 && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.subPackage2}`}</FormHelperText>
                          )}
                        </Grid2>
                      )}
                    </Grid2>
                    <Divider
                      sx={{
                        width: "100%",
                        mb: 2,
                        mt: 2,
                        borderBottomWidth: "medium",
                      }}
                    />
                    <Grid2 container spacing={2}>
                      <Grid2 size={12}>
                        <Typography
                          variant="h4"
                          gutterBottom
                          sx={{ fontSize: "20px", color: "#252525" }}
                        >
                          Enter Issue Details
                        </Typography>
                      </Grid2>
                      {/* <Grid2 size={{xs: 12, md: 6}}>
                        <Autocomplete
                          options={workflowList?.data?.data || []}
                          getOptionLabel={(option) => option?.workflowName}
                          value={workflowList?.data?.data?.find((option) => option?.id === values?.WorkflowApprovalId) || null}
                          onChange={(_, newValue) => setFieldValue("WorkflowApprovalId", newValue ? newValue?.id : "")}
                          onBlur={() => setTouched({ ...touched, WorkflowApprovalId: true })}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Workflow"
                              placeholder='Select Workflow'
                              name="WorkflowApprovalId"
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.WorkflowApprovalId && errors?.WorkflowApprovalId &&
                          <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>{`${errors?.WorkflowApprovalId}`}</FormHelperText>
                        }
                      </Grid2> */}
                      <Grid2 size={{xs: 12, md: 6}}>
                        <Autocomplete
                          options={contractors?.data}
                          disabled={isViewIssueModal}
                          getOptionLabel={(option) => option.name}
                          value={
                            contractors?.data.find(
                              (option) => option.id === values.contractor
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "contractor",
                              newValue ? newValue.id : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, contractor: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Consultant/Contractor"
                              name="contractor"
                              // error={touched.contractor && Boolean(errors.contractor)}
                              // helperText={touched.contractor && errors.contractor}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.contractor && errors?.contractor && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.contractor}`}</FormHelperText>
                        )}
                      </Grid2>

                      <Grid2 size={{xs: 12, md: 6}}>
                        <TextField
                          id="outlined-multiline-staticrequired_by"
                          label="Action Required By"
                          name="actionRequiredBy"
                          fullWidth
                          value={values?.actionRequiredBy}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, actionRequiredBy: true })
                          }
                          slotProps={{ inputLabel: { shrink: true } }}
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.actionRequiredBy &&
                          errors?.actionRequiredBy && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.actionRequiredBy}`}</FormHelperText>
                          )}
                      </Grid2>
                      <Grid2 size={{xs: 12, md: 6}}>
                        <TextField
                          id="outlined-multiline-staticrequired_by_email"
                          label="Action Required By Email"
                          name="actionRequiredByEmail"
                          fullWidth
                          value={values?.actionRequiredByEmail}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              actionRequiredByEmail: true,
                            })
                          }
                          slotProps={{ inputLabel: { shrink: true } }}
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.actionRequiredByEmail &&
                          errors?.actionRequiredByEmail && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.actionRequiredByEmail}`}</FormHelperText>
                          )}
                      </Grid2>
                      <Grid2 size={{xs: 12, md: 6}}>
                        <Autocomplete
                          options={currentStatuses}
                          disabled={isViewIssueModal}
                          getOptionLabel={(option) => option?.label}
                          value={
                            currentStatuses.find(
                              (option) => option.label === values?.currentStatus
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "currentStatus",
                              newValue ? newValue.label : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, currentStatus: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Current Status"
                              name="currentStatus"
                              // error={touched?.package && Boolean(errors?.package)}
                              // helperText={touched?.package && errors?.package}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.currentStatus && errors?.currentStatus && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.currentStatus}`}</FormHelperText>
                        )}
                      </Grid2>
                      <Grid2 size={{xs: 12, md: 6}}>
                        <TextField
                          id="outlined-multiline-static1"
                          disabled={isViewIssueModal}
                          label="Time Impact"
                          name="timeImpact"
                          fullWidth
                          value={values?.timeImpact}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, timeImpact: true })
                          }
                          slotProps={{ inputLabel: { shrink: true } }}
                          variant="filled"
                        />
                        {touched?.timeImpact && errors?.timeImpact && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.timeImpact}`}</FormHelperText>
                        )}
                      </Grid2>
                      <Grid2 size={{xs: 12, md: 6}}>
                        <TextField
                          id="outlined-multiline-static2"
                          disabled={isViewIssueModal}
                          label="Cost Impact"
                          name="costImpact"
                          fullWidth
                          value={values?.costImpact}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, costImpact: true })
                          }
                          slotProps={{ inputLabel: { shrink: true } }}
                          variant="filled"
                        />
                        {touched?.costImpact && errors?.costImpact && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.costImpact}`}</FormHelperText>
                        )}
                      </Grid2>
                      <Grid2 size={{xs: 12, md: 6}}>
                        <Autocomplete
                          options={moduleTypes}
                          getOptionLabel={(option) => option?.label}
                          disabled={isViewIssueModal}
                          value={
                            moduleTypes.find(
                              (option) => option.value === values?.module
                            ) || null
                          }
                          onChange={(_, newValue) => {
                            setFieldValue(
                              "module",
                              newValue ? newValue?.value : ""
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Module"
                              name="module"
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.module && errors?.module && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.module}`}</FormHelperText>
                        )}
                      </Grid2>
                      <Grid2 size={{xs: 12, md: 6}}>
                        <Autocomplete
                          options={severityTypes}
                          getOptionLabel={(option) => option?.label}
                          disabled={isViewIssueModal}
                          value={
                            severityTypes.find(
                              (option) => option.value === values?.severity
                            ) || null
                          }
                          onChange={(_, newValue) => {
                            setFieldValue(
                              "severity",
                              newValue ? newValue?.value : ""
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Severity"
                              name="severity"
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.severity && errors?.severity && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.severity}`}</FormHelperText>
                        )}
                      </Grid2>
                      <Grid2 size={{xs: 12, md: 6}}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Reporting Date"
                            value={
                              values?.reportedDate
                                ? dayjs(values.reportedDate)
                                : null
                            }
                            format="DD-MM-YYYY"
                            disabled={isViewIssueModal}
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "reportedDate",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                            slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                reportedDate: true,
                              })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 16, fontWeight: 400 },
                                  shrink: true
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 16,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.reportedDate && errors?.reportedDate && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.reportedDate}`}</FormHelperText>
                          )}
                        </LocalizationProvider>
                      </Grid2>
                      <Grid2 size={{xs: 12, md: 6}}>
                        <TextField
                          disabled={isViewIssueModal}
                          id="outlined-multiline-static2"
                          label="Issue Description"
                          name="issueDescription"
                          fullWidth
                          value={values?.issueDescription}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, issueDescription: true })
                          }
                          slotProps={{ inputLabel: { shrink: true } }}
                          variant="filled"
                        />
                        {touched?.issueDescription &&
                          errors?.issueDescription && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.issueDescription}`}</FormHelperText>
                          )}
                      </Grid2>
                      <Grid2 size={12}>
                        {isViewIssueModal &&
                          issueDetail?.data?.files?.length > 0 && (
                            <>
                              <List dense={dense}>
                                {issueDetail?.data?.files?.map(
                                  (file, index) => (
                                    <ListItem
                                      key={index}
                                      sx={{ padding: 0 }}
                                      secondaryAction={
                                        <></>
                                        // <IconButton edge="end" aria-label="delete" role="link" onClick={() => handleRemoveFile(index)}>
                                        //     <RxCross2 />
                                        // </IconButton>
                                      }
                                    >
                                      <ListItemAvatar>
                                        <Avatar sx={{ background: "none" }}>
                                          <FaRegFileLines
                                            fontSize="inherit"
                                            style={{ color: "#474747" }}
                                          />
                                        </Avatar>
                                      </ListItemAvatar>
                                      <ListItemText
                                        primary={
                                          <span
                                            style={{
                                              cursor: "pointer",
                                              color: "#474747",
                                              textDecoration: "underline",
                                            }}
                                            onClick={() => {
                                              window.open(
                                                `${API_END_POINT}issues/view/${file?.name}`,
                                                "_blank"
                                              );
                                            }}
                                          >
                                            {file?.name}
                                          </span>
                                        }
                                        secondary={
                                          secondary ? "Secondary text" : null
                                        }
                                      />
                                    </ListItem>
                                  )
                                )}
                              </List>
                            </>
                          )}
                      </Grid2>
                      {!isViewIssueModal && (
                        <>
                          <Grid2 size={12}>
                            {file?.length > 0 ? (
                              <>
                                <List dense={dense}>
                                  {file.map((file, index) => (
                                    <ListItem
                                      key={index}
                                      sx={{
                                        padding: 0,
                                      }}
                                      secondaryAction={
                                        <IconButton
                                          edge="end"
                                          aria-label="delete"
                                          onClick={() =>
                                            handleRemoveFile(index)
                                          }
                                        >
                                          <RxCross2 />
                                        </IconButton>
                                      }
                                    >
                                      <ListItemAvatar>
                                        <Avatar sx={{ background: "none" }}>
                                          <FaRegFileLines
                                            fontSize="inherit"
                                            style={{ color: "#474747" }}
                                          />
                                        </Avatar>
                                      </ListItemAvatar>
                                      <ListItemText
                                        primary={`${file?.name}`}
                                        secondary={
                                          secondary ? "Secondary text" : null
                                        }
                                      />
                                    </ListItem>
                                  ))}
                                </List>
                              </>
                            ) : (
                              <>
                                {/* <DragAndDropUpload onDrop={handleDrop} multi={true}/> */}
                              </>
                            )}
                          </Grid2>
                          <Grid2 size={12}>
                            <DragAndDropUpload
                              onDrop={handleDrop}
                              multi={true}
                            />
                          </Grid2>
                        </>
                      )}

                      <Grid2 size={12}>
                        {/* <Button onClick={cancelIssue} variant='outlined' sx={{
                                                    color: `${newtheme?.customSettings?.themeColor}`, border: `1px solid ${newtheme?.customSettings?.themeColor}`, padding: '6px 20px', fontWeight: '500', textTransform: 'none', float: 'right', fontSize: '16px'
                                                }}>
                                                    Cancel
                                                </Button> */}
                        {!isViewIssueModal && (
                          <Button
                            type="submit"
                            loading={isLoading}
                            variant="contained"
                            sx={{
                              marginRight: "20px",
                              backgroundColor: `${newtheme?.customSettings?.themeColor}`,
                              color: "#FFF",
                              padding: "6px 20px",
                              fontWeight: "500",
                              textTransform: "none",
                              float: "right",
                              fontSize: "16px",
                            }}
                          >
                            Edit Issue
                          </Button>
                        )}
                      </Grid2>
                    </Grid2>
                  </form>
                )}
              </Formik>
            </Box>
          </ThemeProvider>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
